<template>
	<div class="policyDe">
		<div class="policyDeCon">
			<div class="left" v-loading="loading">
				<div class="title">{{title}}</div>
				<div class="text" v-html="content"></div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'agreement',
		data() {
			return {
				title:'',
				type:2,
				content:null,
				loading:false
			}
		},
		created() {
			if(this.$route.query.type) this.type = this.$route.query.type
			this.getAgreement()
		},
		watch:{
			$route() {
				if(this.$route.query.type) this.type = this.$route.query.type
				this.getAgreement()
			}
		},
		methods: {
			getAgreement(){
				this.loading = true
				this.$axios.get('/api/client/Common/getAgreements',{params:{id:this.type}}).then(res=>{
					this.loading = false
					if(res.code==200){
						this.title = res.data.title
						this.content = res.data.content
					}else{
						this.$eltips(res.msg,'error')
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.policyDe{
		position: relative;
		box-sizing: border-box;
		padding: 38px 0;
		display: flex;
		justify-content: center;
		min-height: calc(100vh - 56px - 325px);
		.policyDeCon{
			display: flex;
			margin: 0 auto;
			width: 1200px;
			position: relative;
			z-index: 2;
			overflow: hidden;
			.left{
				flex: 1;
				background-color: #FFF;
				.title{
					font-size: 24px;
					font-weight: bold;
					margin-bottom: 38px;
				}
				.text{
					text-align: justify;
				}
			}
		}
	}
</style>